module.exports = __webpack_public_path__ + "img/vol06_character_thumb08.0a6c435b.png";